import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";

import HomePage from "@/pages/home-page";

export const Route = createFileRoute("/")({
  component: () => <HomePage />,
});
